import { Divider, Stack, Typography } from '@mui/material';
import { useScimIdPs } from 'api/idps';
import IdPMethodCard from 'components/IdPsGallery/IdPMethodCard';
import IdpGallery from 'components/IdPsGallery/IdPsGallery';
import SearchInput from 'components/shared/SearchInput';
import { GENERIC_IDP_ID, SCIMMethod } from 'consts';
import { useIdPConfigContext } from 'contexts/IdPConfigContext';
import { useCurrentSCIMMethod } from 'contexts/SSOConfigFieldsContext';
import React, { useCallback, useMemo, useState } from 'react';
import { useStepNavigate } from 'utils/navigation';

const SelectSCIMIdPPage: React.FC = () => {
	const { data: idps } = useScimIdPs();
	const [idpSearch, setIdpSearch] = useState('');
	const { navigateToScimStep } = useStepNavigate();
	const { scimIdpID } = useIdPConfigContext();
	const currentMethod = useCurrentSCIMMethod();

	const navigateToFirstStep = useCallback(
		(idpID: string) => {
			const method =
				(idps?.find((idp) => idp.id === idpID)
					?.scimMethods?.[0] as SCIMMethod) || SCIMMethod.Generic;
			navigateToScimStep(1, idpID, method);
		},
		[idps, navigateToScimStep]
	);

	const genericIdP = useMemo(
		() => idps?.find((idp) => idp.id === GENERIC_IDP_ID),
		[idps]
	);

	return (
		<Stack gap={4}>
			<Stack gap={0.5}>
				<Typography variant="h2">
					{intl.tr('scimConfig.guide.selectIdP.pageTitle')}
				</Typography>
				<Typography>
					{intl.tr('scimConfig.guide.selectIdP.pageSubheader')}
				</Typography>
			</Stack>
			<Stack gap={3}>
				<SearchInput
					data-testid="idps-gallery-search"
					sx={{ maxWidth: 528, height: 50 }}
					onSearchChange={setIdpSearch}
				/>
				<IdpGallery
					idps={idps?.filter((idp) => idp !== genericIdP) || []}
					loader={!idps}
					filterText={idpSearch}
					selectedIdP={scimIdpID}
					onIdPCardClick={navigateToFirstStep}
				/>
			</Stack>
			<Divider>{intl.tr('scimConfig.guide.selectIdP.divider.or')}</Divider>
			<Stack gap={2}>
				<Typography>
					{intl.tr('scimConfig.guide.selectIdP.custom.message')}
				</Typography>
				<Stack direction="row" gap={3}>
					{genericIdP && (
						<IdPMethodCard
							idp={genericIdP}
							method={SCIMMethod.Generic}
							selectedIdP={scimIdpID}
							selectedMethod={currentMethod}
							onClick={() => {
								navigateToFirstStep(GENERIC_IDP_ID);
							}}
						/>
					)}
				</Stack>
			</Stack>
		</Stack>
	);
};

export default SelectSCIMIdPPage;
